import * as types from './mutation-types';
import * as actions from './actions';

const state  = {
    helpTopics: [],
    isViewing: false,
    tempHelpTopicKey: null,
    componentHelpTopicKey: null,
    routeHelpTopicKey: null,
    defaultHelpTopicKey: 'default-topic',
}

const getters = {
    helpTopics: state => state.helpTopics,
    isViewingHelp: state => state.isViewing,
    tempHelpTopicKey: state => state.tempHelpTopicKey,
    componentHelpTopicKey: state => state.componentHelpTopicKey,
    routeHelpTopicKey: state => state.routeHelpTopicKey,
    defaultHelpTopicKey: state => state.defaultHelpTopicKey,
    helpTopicByKey: (state) => (topicKey) => state.helpTopics.find(eachHelpTopic => eachHelpTopic.topickey === topicKey),
}

const mutations = {
  [types.SET_HELP_TOPICS](state, helpTopics){
    state.helpTopics = helpTopics;
  },
  [types.SET_IS_VIEWING_HELP](state, isViewing){
    state.isViewing = isViewing;
  },
  [types.SET_TEMP_HELP_TOPIC_KEY](state, topicKey){
    state.tempHelpTopicKey = topicKey;
  },
  [types.SET_COMPONENT_HELP_TOPIC_KEY](state, topicKey){
    state.componentHelpTopicKey = topicKey;
  },
  [types.SET_ROUTE_HELP_TOPIC_KEY](state, topicKey){
    state.routeHelpTopicKey = topicKey;
  },
  [types.SET_DEFAULT_HELP_TOPIC_KEY](state, topicKey){
      state.defaultHelpTopicKey = topicKey;
  },

}

export default{
    state,
    getters,
    actions,
    mutations
}
